import { ref } from 'vue';
import { filterListToOptions, sequence, filterEntityFolderToOptions } from '@/ui/helpers/uiHelper';
import { useTask } from '@/ui/concerns';
import { filter as getAllEntityItems } from '@/services/api/resources/entityItem';
import { filter as getAllGroups } from '@/services/api/resources/group';
import { filter as getAllUsers } from '@/services/api/resources/user';
import { filter as getAllCategories } from '@/services/api/resources/category';
import { filter as getAllChecklists } from '@/services/api/resources/checklist';
import { filter as getAllSections } from '@/services/api/resources/section';
import { list as getAllEntityFoldersWithEntityItems, entityFolderDefaultQuery } from '@/services/api/resources/entityFolder';
import { SelectOptions } from '@/ui/types';

export function useFilters() {
  const entityItems = ref([] as SelectOptions);
  const groups = ref([] as SelectOptions);
  const users = ref([] as SelectOptions);
  const categories = ref([] as SelectOptions);
  const checklists = ref([] as SelectOptions);
  const inspections = ref([] as SelectOptions);
  const sections = ref([] as SelectOptions<string>);
  const entityFolders = ref([] as SelectOptions<string>);

  const getFilters = useTask(
    () => sequence(
      getAllGroups(),
      getAllEntityItems(),
      getAllUsers(),
      getAllCategories(),
      getAllChecklists(),
      getAllSections(),
      getAllEntityFoldersWithEntityItems(entityFolderDefaultQuery()),
    ),
    ([groupList, entityItemList, userList, categoryList, checklistList, sectionList, entityFolderList]) => {
      entityItems.value = filterListToOptions(entityItemList);
      groups.value = filterListToOptions(groupList);
      users.value = filterListToOptions(userList);
      categories.value = filterListToOptions(categoryList);
      checklists.value = filterListToOptions(checklistList);
      sections.value = filterListToOptions(sectionList);
      entityFolders.value = filterEntityFolderToOptions(entityFolderList);
    },
  );

  return {
    getFilters,
    entityItems,
    entityFolders,
    groups,
    users,
    categories,
    checklists,
    inspections,
    sections,
  };
}
